import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { environment } from '@env/environment';

import { SessionEndService } from './core/auth/session-end.service';
import { SessionTimeoutService } from './core/auth/session-timeout.service';
import { LoginModel } from './core/models/application.models';
import { CacheBusterService } from './core/services/cache-buster.service';
import { CustomToastsService } from './core/services/custom-toasts.service';
import { PosService } from './core/services/pos.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private toast = inject(CustomToastsService);
  private posService = inject(PosService);
  private cacheBusterService = inject(CacheBusterService);
  private cookieService = inject(CookieService);
  private sessionTimeoutService = inject(SessionTimeoutService);
  private sessionEnd = inject(SessionEndService);

  title = 'app';
  successMsg: string = '';
  showSuccess: boolean = false;
  errorMsg: string = '';
  showError: boolean = false;
  userInfo: LoginModel = new LoginModel();

  ngOnInit() {
    this.cacheBusterService.init();
    this.sessionTimeoutService.startSessionTimer();

    this.toast.successMessage$.subscribe(msg => {
      if (msg) {
        this.successMsg = msg;
        this.showSuccess = true;
      } else {
        this.showSuccess = false;
      }
    });

    this.toast.errorMessage$.subscribe(msg => {
      if (msg) {
        this.errorMsg = msg;
        this.showError = true;
      } else {
        this.showError = false;
      }
    });

    setInterval(() => {
      const cookies = document.cookie.split(';').map(c => c.trim());
      const logoutCookie = cookies.find(c => c.startsWith('logoutEvent='));
      if (logoutCookie) {
        this.logout(); // Call your logout logic
        this.cookieService.delete('logoutEvent', '/');
        this.cookieService.delete('logoutEvent', '/', `.${environment.domainName}`);
      }
    }, 3000);

    const perfEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    if (perfEntries.length && perfEntries[0].type === 'reload') {
      this.onBrowserRefresh();
    }
  }

  onBrowserRefresh() {
    this.posService.rolesLoaded = false;
  }

  logout() {
    this.sessionEnd.end(() => {
      this.cookieService.deleteAll('/', environment.domainName);
      window.location.href = `${environment.companyWebBaseUrl}/shared/login`;
    });
  }
}
